var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _polygon, _polygon2, _path14, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSurveyingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 50 50",
    "data-name": "Layer 1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}.cls-2{fill:#ffffff;}.cls-3{fill:#00a1d3;}.cls-4{fill:#f7d2d0;}.cls-5{fill:#c6b9c4;}.cls-6{fill:#ff8e5a;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.5,18.207a.5.5,0,0,0-.146-.353L42.2,14.7a.5.5,0,0,0-.707,0L33.22,22.969V7a2.5,2.5,0,0,0-2.5-2.5H7A2.5,2.5,0,0,0,4.5,7V43A2.5,2.5,0,0,0,7,45.5H30.72a2.5,2.5,0,0,0,2.5-2.5V30.694L45.354,18.561A.5.5,0,0,0,45.5,18.207Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.008,29.182a.5.5,0,0,0-.1.152l-2.2,5.011a.758.758,0,0,0,.109.9.717.717,0,0,0,.511.208.773.773,0,0,0,.358-.088l3.687-1.62v7.936H8.073V8.321h4.241a3.178,3.178,0,0,0,2.7,1.517H22.7a3.178,3.178,0,0,0,2.7-1.517h3.96v18.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32.22,43a1.5,1.5,0,0,1-1.5,1.5H7A1.5,1.5,0,0,1,5.5,43V7A1.5,1.5,0,0,1,7,5.5h4.829V6.65a3.15,3.15,0,0,0,.074.671H7.573a.5.5,0,0,0-.5.5V42.179a.5.5,0,0,0,.5.5H29.866a.5.5,0,0,0,.5-.5V33.3l.352-.155a.5.5,0,0,0,.153-.1l1.349-1.35Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.525,15.813H27.7a.5.5,0,0,0,0-1H18.525a.5.5,0,0,0,0,1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.083,14.131,12.934,15.28l-.443-.443a.5.5,0,1,0-.707.707l.8.8a.5.5,0,0,0,.707,0l1.5-1.5a.5.5,0,0,0-.707-.707Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.1,11.735a3.577,3.577,0,1,0,3.576,3.578A3.582,3.582,0,0,0,13.1,11.735Zm0,6.154a2.577,2.577,0,1,1,2.576-2.576A2.58,2.58,0,0,1,13.1,17.889Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.7,24.5H18.525a.5.5,0,0,0,0,1H27.7a.5.5,0,0,0,0-1Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.083,23.818l-1.149,1.15-.443-.444a.5.5,0,1,0-.707.707l.8.8a.5.5,0,0,0,.707,0l1.5-1.5a.5.5,0,0,0-.707-.707Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.1,21.424A3.576,3.576,0,1,0,16.675,25,3.581,3.581,0,0,0,13.1,21.424Zm0,6.152A2.576,2.576,0,1,1,15.675,25,2.579,2.579,0,0,1,13.1,27.576Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.452,34.188H18.525a.5.5,0,0,0,0,1h3.927a.5.5,0,0,0,0-1Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.083,33.507l-1.149,1.148-.443-.442a.5.5,0,1,0-.707.707l.8.8a.5.5,0,0,0,.707,0l1.5-1.5a.5.5,0,0,0-.707-.707Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.1,31.111a3.577,3.577,0,1,0,3.576,3.577A3.582,3.582,0,0,0,13.1,31.111Zm0,6.154a2.577,2.577,0,1,1,2.576-2.577A2.581,2.581,0,0,1,13.1,37.265Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32.22,7V23.968h0l-1.854,1.854v-18a.5.5,0,0,0-.5-.5H25.818a3.215,3.215,0,0,0,.074-.671V5.5H30.72A1.5,1.5,0,0,1,32.22,7Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "28.053 33.228 26.824 31.998 27.604 30.224 29.827 32.448 28.053 33.228"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "26.393 32.98 27.071 33.66 25.86 34.192 26.393 32.98"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M24.892,6.65A2.191,2.191,0,0,1,22.7,8.838H15.016A2.19,2.19,0,0,1,12.829,6.65V5.5H24.892Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    height: 3.463,
    transform: "translate(-6.217 32.602) rotate(-45)",
    width: 19.298,
    x: 26.597,
    y: 22.074
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyingIcon);
export default __webpack_public_path__ + "static/media/surveyingIcon.c9c971b1bbd4f7948b19a3738dbfcce7.svg";
export { ForwardRef as ReactComponent };